import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InsuranceSuggestion } from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class ICListHttpService {
  private readonly icListUrl = '/api/partners/ic/list';

  constructor(private readonly httpClient: HttpClient) {}

  getICList() {
    return this.httpClient.get<InsuranceSuggestion[]>(this.icListUrl, {
      headers: { requestName: 'iclist-http getICList' },
    });
  }
}
